/* eslint-disable react/prefer-stateless-function */
import React from "react";
// Items commented out in this module allow users to use this feature during Free-Trial period
// import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { DropdownItem, DropdownMenu, UncontrolledDropdown, DropdownToggle } from "reactstrap";
import LevelSelect from "./LevelSelect";
// import { SubsContext } from '../Billsby/SubscriptionInfo';
import { isFeatureEnabled } from "../../config/featureFlags";


const SubscriptionLevel = ({ auth, onSelect }) => {
  // const { subscription } = useContext(SubsContext);
  const currentUrl = window.location.href;
  const hostUrl = window.location.origin;
  const path = currentUrl.replace(hostUrl, '');
  const usage = `This menu allows you to temporarily set the Subscription Level to test how the various
  features of ICON are affected by a given level.  This will help you evaluate your need for those features.
  The level selected here will remain in effect until you reload the page or log out.`;

  return (
    <div title={usage}>
      {isFeatureEnabled('ENABLE_BILLSBY') && (/* subscription && subscription.status === 'InTrial' || */ auth.role && auth.role.toUpperCase().includes('SUPER_ADMIN')) && (
        <DropdownItem>
          <UncontrolledDropdown onClick={(e) => { e.stopPropagation(); }}>
            <DropdownToggle caret>
              Set Subscription Level Temporarily
            </DropdownToggle>
            <DropdownMenu right>
              <LevelSelect level="ICON Core" onSelect={onSelect} path={path} />
              <LevelSelect level="ICON Plus" onSelect={onSelect} path={path} />
              <LevelSelect level="ICON Pro" onSelect={onSelect} path={path} />
            </DropdownMenu>
          </UncontrolledDropdown>
        </DropdownItem>
      )}
    </div>
  );
}

SubscriptionLevel.propTypes = {
  auth: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
}

export default SubscriptionLevel;



// WEBPACK FOOTER //
// ./src/components/Subscription/SubscriptionLevel.jsx